export enum EAgentNotifyWhen {
  onlyWithQualifiedLeads = 'onlyWithQualifiedLeads',
  afterAllChats = 'afterAllChats',
}

export enum ECTAFriendly {
  schedule = 'Schedule an appointment',
  custom = 'Custom',
}

export enum ECTAValues {
  schedule = 'schedule',
  custom = 'custom',
}

export enum ENotificationType {
  email = 'email',
  text = 'text',
  emailAndText = 'emailAndText',
}

export enum EPersonalityFriendlyName {
  professional = 'Professional',
  jokey = 'Jokey',
  enthusiastic = 'Enthusiastic',
  laidBack = 'Laid Back',
}

export enum EPersonalityValues {
  professional = 'professional',
  jokey = 'jokey',
  enthusiastic = 'enthusiastic',
  laidBack = 'laidBack',
}

export const personalityMapping = {
  [EPersonalityFriendlyName.professional]: EPersonalityValues.professional,
  [EPersonalityFriendlyName.jokey]: EPersonalityValues.jokey,
  [EPersonalityFriendlyName.enthusiastic]: EPersonalityValues.enthusiastic,
  [EPersonalityFriendlyName.laidBack]: EPersonalityValues.laidBack,
}

export enum ESchedule {
  askForAvailability = 'Ask for availability',
  calendly = 'Calendar link',
}

export enum EScheduleValues {
  askForAvailability = 'askForAvailability',
  calendly = 'Calendly',
}

export enum ELocationType {
  anywhere = 'Anywhere',
  in = 'Customer comes to me',
  out = 'I go to the customer',
}

export enum ELocationTypeValues {
  anywhere = 'anywhere',
  in = 'in',
  out = 'out',
}

export enum EMessageSpeaker {
  user = 'user',
  assistant = 'assistant',
  system = 'system',
}

export enum ETextMethodValues {
  SMS = 'SMS',
  whatsapp = 'WhatsApp',
}

export enum EContactQualification {
  qualified = 'qualified',
  disqualified = 'disqualified',
  undetermined = 'undetermined',
  unknown = 'unknown',
}

export enum EContactStatus {
  new = 'New',
  working = 'Working',
  scheduled = 'Scheduled',
  done = 'Done',
}

export enum EConversationChannel {
  phone = 'phone',
  email = 'email',
  text = 'text',
  chatbot = 'chatbot',
}

export enum EConversationRating {
  good = 1,
  bad = 0,
}

export type TContact = {
  id: string
  agentId?: string
  createdDate: Date
  name?: string
  email?: string
  emailBlocked?: boolean
  phone?: string
  phoneBlocked?: boolean
  source?: string
  status?: EContactStatus
  qualification?: EContactQualification
  updatedDate: Date
  aiNextSteps?: string
  lastActivity?: string
  hasUnreadConversation: boolean
  streetAddress1?: string
  streetAddress2?: string
  city?: string
  state?: string
  zipCode?: string
  country?: string
  firstName?: string
  lastName?: string
  read?: boolean
  lastReadFeedItem?: string
  textBlocked?: boolean
}

export type TConversation = {
  id: string
  contactId?: string
  contact: TContact
  createdDate?: Date
  source?: string
  channel: EConversationChannel
  updatedDate: Date
  messages: TMessage[] | []
  audioFileLink?: string
  lastActivity?: Date
  summary?: string
  read: boolean
  conversationRating: EConversationRating | null
  ratingNotes?: string
  hasContactInfo: boolean
  subject: string
  leftVoicemail: boolean
  sentLinks: string[] | { links: string[] } | null
}

export type TReportContact = TContact & {
  mostRecentConversationDate: Date
}

export type TMessage = {
  id: string
  conversationId: string
  createdDate: Date
  messageText: string
  speaker: EMessageSpeaker
  phone?: string
  email?: string
  updatedDate: Date
  conversation: TConversation
  emailFromName: string
  emailToName: string
  emailToAddress: string
}
